var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Background"},[_c('h2',{staticClass:"Title"},[_vm._v(" 템플릿 ")]),_c('TemplateList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }